import React from 'react'
import ApiRequest from 'EurestoApi/ApiRequest'

import project from 'EurestoConfig/project.config'
import Grid from '@material-ui/core/Grid/Grid'
import DataComponent from 'EurestoComponents/DataComponents'
import Constants from 'EurestoFonction/Constants'
import Input from 'Components/Input'
import Data from 'EurestoClass/Data'
import Utils from 'EurestoFonction/Utils'

export default class extends React.Component {
  constructor (props) {
    super(props)
    this.state = { data: {}, key: Utils.getRandomNumber() }
  }

  async componentDidMount () {
    const id = this.props.params.id
    let paramsSend = { 'id': id, 'requete': 'client', 'action': 'information' }

    const r = await ApiRequest(project.api + 'crm', paramsSend)
    if (r && r.code === 1 && r.results) {
      Data.set(Constants.module.CRM, Constants.donnee.info_tiers, r.results.donnees_complementaires.info_tiers)
      Data.set(Constants.module.CRM, Constants.donnee.info_tiers_donnees, r.results.donnees_complementaires.info_tiers_donnees)
      this.setState({
        data: r.results, key: Utils.getRandomNumber()
      })
    }
  }

  render () {
    return (
      <Grid key={this.state.key} container spacing={0} style={{ margin: 0, padding: 0 }}>
        <Grid item xs={12} style={{
          margin: 0, padding: 0,
          borderBottom: '1px solid lightgrey',
          backgroundColor: '#F9F9F9', height: '100vh', maxHeight: '100vh', overflow: 'auto'
        }}>
          <Grid container spacing={0} style={{ margin: 0, padding: 0 }}>
            <Grid item xs={12} style={{ margin: 0, padding: 0 }}>
              <Grid container spacing={0} style={{ margin: 0, padding: 0 }}>
                <Grid item xs={3} style={{
                  margin: 0, padding: 0,
                  borderRight: '1px solid lightgrey'
                }}>
                  <Grid container spacing={0} style={{ margin: 0, padding: 0 }} direction={'column'}
                        justify={'center'} alignItems={'center'}>
                    <DataComponent
                      onChange={this.handleContactStateChange}
                      name="picture"
                      avatarStyle={{ borderRadius: 20, width: 128, height: 128, }}
                      disabled={true}
                      data={this.state.data.picture}
                      type={Constants.typeSaisie.Picture}
                      defineData={true}
                      object={{
                        picture: this.state.data.picture || { id: undefined, lien: undefined },
                      }}/>
                    <DataComponent
                      onChange={this.handleContactStateChange}
                      name="vip"
                      disabled={true}
                      data={this.state.data.vip}
                      contact={this.state.data}
                      type={Constants.typeSaisie.Stars}
                    />
                    {this.state.data.qualite_id && <label>{this.state.data.qualite}</label>}
                    {this.state.data.type_client_id && <label>{this.state.data.type_client}</label>}
                  </Grid>
                </Grid>

                <Grid item xs={9} style={{ margin: 0, padding: 0, }}>
                  <Grid container spacing={0} style={{ margin: 0, padding: 0, borderBottom: '1px solid lightgrey' }}>
                    <Grid item xs={6} style={{ margin: 0, padding: 5, borderRight: '1px solid lightgrey' }}>
                      <Grid container spacing={0} style={{ margin: 0, padding: 0 }} direction={'column'}
                            justify={'flex-start'} alignItems={'stretch'}>
                        <Input
                          disabled={true}
                          type="text"
                          className="upText"
                          value={(this.state.data.entite === 1 && this.state.data.civilite_id > 0 &&
                            this.state.data.civilite || '')
                          + (this.state.data.nom || '') + (this.state.data.entite === 1 && (' ' + this.state.data.prenom) || '')}
                          title={''}
                        />
                        {this.state.data.email && <Input
                          disabled={true}
                          type="text"
                          className="upText"
                          value={this.state.data.email}
                          title={''}
                        />}
                        {this.state.data.portable && <Input
                          disabled={true}
                          type="text"
                          className="upText"
                          value={this.state.data.portable}
                          title={''}
                        />}
                        {this.state.data.fixe && <Input
                          disabled={true}
                          type="text"
                          className="upText"
                          value={this.state.data.fixe}
                          title={''}
                        />}
                        {this.state.data.adresse1 && <Input
                          disabled={true}
                          type="text"
                          className="upText"
                          value={(this.state.data.adresse1 && (this.state.data.adresse1 + ((this.state.data.adresse2 || this.state.data.adresse3) && ', ' || '')) || '')
                          + (this.state.data.adresse2 && (this.state.data.adresse2 + (this.state.data.adresse3 && ', ' || '')) || '')
                          + (this.state.data.adresse3 && (this.state.data.adresse3 + '') || '')}
                          title={''}
                        />}
                        {(this.state.data.cp || this.state.data.ville) && <Input
                          disabled={true}
                          type="text"
                          className="upText"
                          value={(this.state.data.cp && (this.state.data.cp + (this.state.data.ville && ', ' || '')) || '') + (this.state.data.ville && (this.state.data.ville + '') || '')}
                          title={''}
                        />}

                        {(this.state.data.relations || []).length > 0 && <Grid container style={{
                          margin: 0,
                          padding: 0,
                          borderBottom: '1px solid rgba(255,255,255,0.20)',
                          borderTop: '1px solid rgba(0,0,0,0.80)',
                          backgroundColor: 'lightgrey',
                          cursor: 'pointer'
                        }} spacing={0} justify={'space-between'}
                                                                               alignItems={'center'}
                                                                               onClick={() => this.setState({
                                                                                 relationExpended: !(this.state.relationExpended || false)
                                                                               })}>
                          <strong style={{ marginLeft: 3 }}>Relations</strong>

                          <Grid item style={{ margin: 0, padding: 0, marginRight: 3 }}>
                            <i
                              className={'ei-commun_carre_' + (this.state.relationExpended ? 'moins' : 'plus') + ' EurestoPrimary--text'}/>
                          </Grid>
                        </Grid>}
                        {(this.state.data.relations || []).length > 0 && this.state.relationExpended &&
                        <Grid container
                              style={{
                                margin: 0,
                                padding: 0,
                                borderTop: '2px solid rgba(0,0,0,0.80)',
                                borderBottom: '1px solid lightgrey',
                                backgroundColor: '#F9F9F9'
                              }}
                              spacing={0} justify={'flex-start'}
                              alignItems={'flex-start'}>
                          {
                            (this.state.data.relations || []).map((r, i) =>
                              <Grid key={r.contact_id + '-' + r.relation_id + ' _' + this.state.client_id} item xs={12}
                                    style={{
                                      margin: 0,
                                      padding: 5,
                                      textDecoration: 'underline'
                                    }}>
                                <Grid container style={{ margin: 0, padding: 0 }} spacing={0} justify={'flex-start'}
                                      alignItems={'flex-start'}>
                                  < Grid item xs={12} style={{
                                    margin: 0,
                                    padding: 0,
                                    textAlign: 'left'
                                  }}>{r.contact_libelle} ({r.relation_libelle})</Grid>
                                </Grid>
                              </Grid>
                            )
                          }
                        </Grid>}
                      </Grid>
                    </Grid>

                    <Grid item xs={6} style={{
                      margin: 0,
                      padding: 5,
                      borderLeft: '1px solid lightgrey',
                      maxHeight: 200,
                      overflowY: 'auto',
                      overflowX: 'hidden'
                    }}>
                      <Grid container spacing={0} style={{ margin: 0, padding: 0 }} direction={'column'}
                            justify={'flex-start'} alignItems={'stretch'}>
                        {
                          Object.keys(this.state.data.information_tiers || {}).map(i => {
                            const infoTiers = this.state.data.information_tiers[i]
                            const info = Data.get(Constants.module.CRM, Constants.donnee.info_tiers, { id: i }) || {}
                            return <DataComponent
                              key={i}
                              name={i}
                              //style={{ padding: 10 }}
                              title={info.libelle}
                              disabled={true}
                              infoTiers={true}
                              object={Constants.donnee.info_tiers_donnees}
                              module={Constants.module.CRM}
                              data={infoTiers}
                              type={info.type_saisie_id}
                              />
                          })
                        }
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    )
  }

}





// WEBPACK FOOTER //
// ./app/App/Module/Page/Page/MinatureContact/index.js